import React, { useState, useRef, useEffect } from "react";
import Modal from "react-modal";
import * as BsIcons from "react-bootstrap-icons";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    width: "30%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "20px",
    borderRadius: "10px",
    border: "1px solid #ccc",
    boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
    fontFamily: "Inter, sans-serif",
    overflow: "visible", // permitir desbordar contenido
  },
  overlay: {
    backgroundColor: "rgba(0,0,0,0.4)",
    zIndex: 1008,
  },
  input: {
    width: "100%",
    padding: "8px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
    marginTop: "8px",
    marginBottom: "16px",
    background: "#F8FAFB",
  },
  colorPicker: {
    width: "100%",
    height: "40px",
    padding: 0,
    border: "1px solid #ccc",
    borderRadius: "5px",
    boxSizing: "border-box",
    cursor: "pointer",
    background: "none",
    marginTop: "8px",
    marginBottom: "16px",
  },
  modalTitle: { marginBottom: "16px", textAlign: "center", color: "#44566C" },
  modalField: {
    marginBottom: "16px",
    display: "flex",
    flexDirection: "column",
  },
  iconRow: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    position: "relative",
    width: "100%",
  },
  iconButton: {
    width: "46px", // Fijo igual que BTN_SIZE
    height: "46px", // Fijo igual que BTN_SIZE
    border: "1px solid #ccc",
    borderRadius: "6px",
    background: "white",
    cursor: "pointer",
    display: "flex",
    fontSize: "18px",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  iconButtonSelected: {
    borderColor: "#007bff",
    boxShadow: "0 0 0 2px rgba(0,123,255,0.25)",
  },
  popover: {
    position: "absolute",
    top: "110%",
    left: 0,
    right: 0,
    background: "#fff",
    border: "1px solid #e2e2e2",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(46px, 1fr))",
    gap: "14px",
    padding: "8px",
    zIndex: 1000,
    maxHeight: "200px",
    overflowY: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "8px",
  },
  btnCancel: {
    padding: "8px 16px",
    border: "1px solid #d1d5db",
    background: "#fff",
    borderRadius: "4px",
    cursor: "pointer",
  },
  btnSave: {
    padding: "8px 16px",
    border: "none",
    backgroundColor: "#2563eb",
    color: "#fff",
    borderRadius: "4px",
    cursor: "pointer",
  },
  closeButton: {
    position: "absolute",
    top: "12px",
    right: "12px",
    background: "#EAEDF0",
    color: "#44566C",
    borderRadius: "50%",
    height: 32,
    width: 32,
    border: "none",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    lineHeight: 0,
    fontSize: 16,
  },
};

// carga de iconos
const ALL_ICONS = Object.entries(BsIcons)
  .filter(([name]) => /^[A-Z]/.test(name))
  .map(([key, Icon]) => ({ key, render: () => <Icon /> }));

const MAIN_KEYS = [
  "CircleFill",
  "TriangleFill",
  "SquareFill",
  "Chat",
  "Clock",
  "Check",
];
const ICONS_MAIN = MAIN_KEYS.map((k) =>
  ALL_ICONS.find((ic) => ic.key === k)
).filter(Boolean);
const ICONS_EXTRA = ALL_ICONS.filter(
  (ic) => !ICONS_MAIN.some((m) => m.key === ic.key)
);

export default function ModalGrupo({
  isOpen,
  closeModal,
  groupName,
  setGroupName,
  groupShape,
  setGroupShape,
  groupColor,
  setGroupColor,
  handleSaveGroup,
}) {
  const [popOpen, setPopOpen] = useState(false);
  const popRef = useRef();

  useEffect(() => {
    const onClickOutside = (e) => {
      if (popRef.current && !popRef.current.contains(e.target)) {
        setPopOpen(false);
      }
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  const selectIcon = (key) => {
    setGroupShape(key);
    setPopOpen(false);
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal} style={customStyles}>
      <button onClick={closeModal} style={customStyles.closeButton}>
        <BsIcons.XLg />
      </button>

      <h2 style={customStyles.modalTitle}>Crear Nuevo Grupo</h2>

      <div style={customStyles.modalField}>
        <label>Título del Grupo:</label>
        <input
          type="text"
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
          style={customStyles.input}
        />
      </div>

      <div style={customStyles.modalField}>
        <label style={{ marginBottom: "5px" }}>Icono:</label>
        <div style={customStyles.iconRow} ref={popRef}>
          {ICONS_MAIN.map((ic) => {
            const sel = groupShape === ic.key;
            return (
              <button
                key={ic.key}
                onClick={() => selectIcon(ic.key)}
                style={{
                  ...customStyles.iconButton,
                  ...(sel ? customStyles.iconButtonSelected : {}),
                  color: groupColor,
                }}
              >
                {ic.render()}
              </button>
            );
          })}

          <button
            onClick={() => setPopOpen((o) => !o)}
            style={customStyles.iconButton}
          >
            <BsIcons.Plus />
          </button>

          {popOpen && (
            <div className="icon-popover" style={customStyles.popover}>
              {ICONS_EXTRA.map((ic) => {
                const sel = groupShape === ic.key;
                return (
                  <button
                    key={ic.key}
                    onClick={() => selectIcon(ic.key)}
                    style={{
                      ...customStyles.iconButton,
                      ...(sel ? customStyles.iconButtonSelected : {}),
                      color: groupColor,
                    }}
                  >
                    {ic.render()}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <div style={customStyles.modalField}>
        <label>Color del ícono:</label>
        <input
          type="color"
          value={groupColor}
          onChange={(e) => setGroupColor(e.target.value)}
          style={customStyles.colorPicker}
        />
      </div>

      <div style={customStyles.actions}>
        <button onClick={handleSaveGroup} style={customStyles.btnSave}>
          Guardar
        </button>
        <button onClick={closeModal} style={customStyles.btnCancel}>
          Cancelar
        </button>
      </div>
    </Modal>
  );
}
